import { required } from './required';
export function number(value) {
    return value !== '' &&
        value != null &&
        !/^[+-]?([0-9]*\.[0-9]+|[0-9]+)$/.test(value)
        ? 'Enter a number'
        : '';
}
export var requiredNumber = required(number);
//# sourceMappingURL=number.js.map